module.exports = __webpack_public_path__ + "img/youku.5fbf7fe7.png";